/* Private Videoguys storefront integration; no V1 settings or remote requests. */
(function () {
  'use strict';
  if (customElements.get('vg-dispatch-date-v2')) return;
  class DispatchDate extends HTMLElement {
    connectedCallback() {
      this.renderDate = this.renderDate.bind(this);
      this.renderDate();
      // Recalculate at every minute boundary, including cutoff and local midnight.
      this.schedule();
      document.addEventListener('visibilitychange', this.renderDate);
    }
    schedule() {
      this.timer = setTimeout(() => { this.renderDate(); this.schedule(); }, 60000 - Date.now() % 60000 + 20);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.renderDate);
    }
    renderDate() {
      let result = null;
      try { result = window.VideoguysDispatchV2.nextDispatch(JSON.parse(this.dataset.calendar)); } catch (_) { /* Use the non-promissory fallback. */ }
      const text = result ? `${this.dataset.message} ${result.label}` : this.dataset.fallback;
      if (this.textContent !== text) this.textContent = text;
    }
  }
  customElements.define('vg-dispatch-date-v2', DispatchDate);
})();
